module.exports = __webpack_public_path__ + "img/full4-min.50bdd2a7.png";